import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "data-bs-target"]
const _hoisted_2 = ["id", "data-bs-backdrop"]
const _hoisted_3 = {
  key: 0,
  class: "modal-header border-0"
}
const _hoisted_4 = { class: "text-header mb-0" }
const _hoisted_5 = ["id"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    id: {},
    title: {},
    size: {},
    modalBodyId: {},
    bodyClass: { default: "" },
    hasCloseButton: { type: Boolean, default: true },
    hasHeader: { type: Boolean, default: true },
    fullHeight: { type: Boolean, default: false },
    backdrop: { default: "static" },
    modalClass: { default: "text-primary" },
    footerClass: {}
  },
  emits: ["modalClosed"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const modalClosed = () => {
  emit("modalClosed");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      hidden: "",
      id: `${__props.id}_modal_button`,
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${__props.id}`
    }, null, 8, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal fade", __props.modalClass]),
        id: __props.id,
        tabindex: "-1",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
        "data-bs-backdrop": __props.backdrop
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-dialog modal-dialog-centered modal-dialog-scrollable", __props.size])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-content shadow-lg", { 'vh-100': __props.fullHeight }])
          }, [
            (__props.hasHeader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1),
                  (__props.hasCloseButton)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        type: "button",
                        class: "fas fa-times text-muted",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close",
                        onClick: modalClosed
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.$slots.body)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["modal-body border-0", __props.bodyClass]),
                  id: __props.modalBodyId
                }, [
                  _renderSlot(_ctx.$slots, "body")
                ], 10, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.$slots.footer)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["modal-footer border-0", __props.footerClass])
                }, [
                  _renderSlot(_ctx.$slots, "footer")
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.$slots.content)
              ? _renderSlot(_ctx.$slots, "content", {}, undefined, undefined, 3)
              : _createCommentVNode("", true)
          ], 2)
        ], 2)
      ], 10, _hoisted_2)
    ]))
  ]))
}
}

})